import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography, Grid, Card, CardMedia, CardContent, Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { images } from '../assets/images';

const BlogList: React.FC = () => {
  const posts = [
    {
      id: 'innovation-in-farming',
      title: 'Innovation in Farming',
      image: images.analytics,
      description: 'Discover the latest agricultural technologies',
    },
    {
      id: 'data-analytics',
      title: 'Data Analytics',
      image: images.innovation,
      description: 'Using data to improve farm yields',
    },
    {
      id: 'sustainable-practices',
      title: 'Sustainable Practices',
      image: images.sustainable,
      description: 'Eco-friendly farming methods',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" gutterBottom>
        Blog
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Insights and stories from across modern agriculture and agritech.
      </Typography>
      <Grid container spacing={4}>
        {posts.map((post) => (
          <Grid item xs={12} md={4} key={post.id}>
            <Card>
              <CardMedia component="img" height="200" image={post.image} alt={post.title} />
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {post.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {post.description}
                </Typography>
                <Button
                  component={Link}
                  to={`/blog/${post.id}`}
                  sx={{ mt: 2 }}
                  endIcon={<ArrowForwardIcon />}
                >
                  Read More
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default BlogList;

